import styled, { css } from 'styled-components';
import { fontDisplay } from '../../theme/typography';

const menuMotion = css`
  opacity: 0;
  transform: translateY(-8px) scale(0.96);
  transition: opacity 160ms ease, transform 160ms ease;
  &[data-open='true'] {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
  @media (prefers-reduced-motion: reduce) {
    transition: none;
    transform: none;
  }
`;

export const StyledLeagueSwitcher = styled.div`
  position: relative;
  z-index: 2;
  flex-shrink: 0;
  min-width: 0;
`;

export const StyledLeagueTrigger = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  max-width: min(280px, 100%);
  margin: 0;
  padding: 8px 12px 8px 8px;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.28);
  background: rgba(0, 0, 0, 0.4);
  color: #fff;
  cursor: pointer;
  font-family: 'Archivo', sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.15;
  text-align: left;
  backdrop-filter: blur(10px);
  @media only screen and (max-width: 768px) {
    width: 100%;
    max-width: none;
  }
  &:hover,
  &:focus-visible {
    border-color: rgba(255, 255, 255, 0.45);
    background: rgba(0, 0, 0, 0.55);
    outline: none;
  }
  &:disabled {
    opacity: 0.6;
    cursor: default;
  }
`;

export const StyledLeagueTriggerName = styled.span`
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const StyledLeagueChevron = styled.span`
  display: inline-flex;
  flex-shrink: 0;
  color: rgba(255, 255, 255, 0.8);
  transition: transform 160ms ease;
  &[data-open='true'] {
    transform: rotate(-180deg);
  }
  svg {
    display: block;
  }
  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

export const StyledLeagueOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 400;
  background: transparent;
  pointer-events: ${({ $open }) => ($open ? 'auto' : 'none')};
`;

export const StyledLeagueMenu = styled.div`
  position: fixed;
  z-index: 401;
  box-sizing: border-box;
  min-width: 0;
  max-height: min(360px, calc(100vh - 24px));
  overflow: auto;
  padding: 6px;
  border-radius: 14px;
  background: ${({ theme }) => theme.card};
  color: ${({ theme }) => theme.text};
  border: 1px solid ${({ theme }) => theme.border};
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.28);
  transform-origin: top right;
  ${menuMotion}
`;

export const StyledLeagueMenuLabel = styled.p`
  margin: 0;
  padding: 8px 10px 6px;
  font-family: 'Archivo', sans-serif;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.textFaint};
`;

export const StyledLeagueOption = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  margin: 0;
  padding: 8px 10px;
  border: none;
  border-radius: 10px;
  background: ${({ $active, theme }) =>
    $active ? theme.hover : 'transparent'};
  color: ${({ theme }) => theme.text};
  cursor: pointer;
  text-align: left;
  font-family: 'Archivo', sans-serif;
  &:hover,
  &:focus-visible {
    background: ${({ theme }) => theme.hover};
    outline: none;
  }
`;

export const StyledLeagueNum = styled.span`
  display: grid;
  place-items: center;
  flex-shrink: 0;
  width: ${({ $compact }) => ($compact ? '22px' : '32px')};
  height: ${({ $compact }) => ($compact ? '22px' : '32px')};
  ${fontDisplay};
  font-style: italic;
  font-synthesis: style;
  font-size: ${({ $compact }) => ($compact ? '18px' : '26px')};
  line-height: 1;
  letter-spacing: -0.04em;
  color: ${({ $compact, theme }) =>
    $compact ? '#fff' : theme.text};
`;

export const StyledLeagueCrest = styled.span`
  display: grid;
  place-items: center;
  flex-shrink: 0;
  width: ${({ $compact }) => ($compact ? '22px' : '32px')};
  height: ${({ $compact }) => ($compact ? '22px' : '32px')};
  background: transparent;
  font-family: 'Archivo', sans-serif;
  font-size: ${({ $compact }) => ($compact ? '10px' : '12px')};
  font-weight: 700;
  color: ${({ $compact, theme }) =>
    $compact ? 'rgba(255, 255, 255, 0.8)' : theme.textMuted};
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const StyledLeagueOptionName = styled.span`
  min-width: 0;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
`;

export const StyledLeagueCheck = styled.span`
  display: inline-flex;
  flex-shrink: 0;
  color: ${({ theme }) => theme.headerAccent};
  svg {
    display: block;
  }
`;
